var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSelect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 1C2.9625 1 0.5 3.4625 0.5 6.5C0.5 9.5375 2.9625 12 6 12C9.0375 12 11.5 9.5375 11.5 6.5C11.5 3.4625 9.0375 1 6 1ZM4.3535 5.3965C4.2592 5.30542 4.1329 5.25502 4.0018 5.25616C3.8707 5.2573 3.74529 5.30989 3.65259 5.40259C3.55989 5.49529 3.5073 5.6207 3.50616 5.7518C3.50502 5.8829 3.55542 6.0092 3.6465 6.1035L5.6465 8.1035C5.74026 8.19724 5.86742 8.24989 6 8.24989C6.13258 8.24989 6.25974 8.19724 6.3535 8.1035L8.3535 6.1035C8.44458 6.0092 8.49498 5.8829 8.49384 5.7518C8.4927 5.6207 8.44011 5.49529 8.34741 5.40259C8.25471 5.30989 8.1293 5.2573 7.9982 5.25616C7.8671 5.25502 7.7408 5.30542 7.6465 5.3965L6 7.043L4.3535 5.3965Z",
    stroke: "none"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelect);
export default __webpack_public_path__ + "static/media/Select.2ace3d9f.svg";
export { ForwardRef as ReactComponent };